import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import crypto from "crypto-js";
import { UpdatePassword } from "../api/Service";

export const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);  // State to control modal visibility
    const navigate = useNavigate();  // Initialize useNavigate

    function decryptData(encryptedData, secret) {
        const [ivHex, encryptedText] = encryptedData.split(':'); // Split IV and encrypted text
        const iv = Buffer.from(ivHex, 'hex');
        const key = crypto.createHash('sha256').update(secret).digest(); // Hash to get a 32-byte key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
        let decrypted = decipher.update(encryptedText, 'hex', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted; // Return decrypted data
    }

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords Do not Match');
        } else {
            setError('');
            try {
                let secretKey = "your_very_secure_long_key_here_12345678";

                // Get the full query string from the URL
                let queryString = window.location.search;

                // Use URLSearchParams to parse the query string
                let urlParams = new URLSearchParams(queryString);

                // Extract the value of the 'token' parameter
                let token = urlParams.get('token');
                // const decryptedData = decryptData(token, secretKey);
                //const [email, otp] = decryptedData.split(':');
                setLoading(true);
                let data = {
                    password: password,
                    token: token
                };
                console.log('enterr')
                const res = await UpdatePassword(data); 
                
                if (res.status === 200) {
                    setLoading(false);
                    setShowModal(true);  
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        }
    }

    const handleCloseModal = () => {
        setShowModal(false);
        navigate('/app/login');  
    }

    return (
        <div className="flex justify-center items-center min-h-screen bg-[#f5f5f5] p-4 font-sans">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
                <div className="flex justify-center mb-8">
                    <h1 className="text-3xl font-bold text-[#121212]">AI Credit Repair</h1>
                </div>
                <h2 className="text-2xl font-semibold mb-6 text-center">Please Enter Your New Password</h2>
                {error && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 relative">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            placeholder="Password*"
                            className="w-full p-3 border border-gray-300 rounded"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-3 text-gray-600"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                    <div className="mb-4 relative">
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            name="confirmPassword"
                            placeholder="Confirm Password*"
                            className="w-full p-3 border border-gray-300 rounded"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-3 text-gray-600"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                    <button
                        type="submit"
                        className="w-full py-3 bg-gradient-to-r from-purple-500 to-red-500 text-white rounded-lg font-semibold hover:from-purple-600 hover:to-red-600"
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Update Password"}
                    </button>
                </form>
            </div>

            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
                        <h3 className="text-xl font-semibold mb-4">Password Updated!</h3>
                        <p>Your password has been updated successfully. You can now log in with your new password.</p>
                        <button
                            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                            onClick={handleCloseModal}  
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};